<template>
  <v-dialog
    v-if="request"
    :value="value"
    width="75vw"
    max-width="1200px"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        <span class="headline">申請の却下</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout column mb-4>
            <v-flex class="label">広告主名</v-flex>
            <v-flex class="value">{{ request.advertiserName }}</v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">案件名</v-flex>
            <v-flex class="value">{{ request.insertionOrderName }}</v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">期間・予算</v-flex>
            <v-flex class="value">
              <v-layout>
                <v-flex sm6>
                  <AppPeriod
                    :start="request.startTime"
                    :end="request.endTime"
                  />
                </v-flex>
                <v-flex sm2 class="text-xs-right">
                  <AppCurrency :value="request.budget" /><br />
                  <NetBudget :value="request.netBudget" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">却下理由（必須）</v-flex>
            <v-flex>
              <v-textarea v-model="reason" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="!isValid" color="primary" @click="reject">却下</v-btn>
        <v-btn color="primary" @click="close">キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NetBudget from './NetBudget.vue'
import { actions } from '@/vuex/modules/admin/request/budget/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'RejectModal',
  components: { NetBudget },
  props: {
    value: Boolean,
    request: Object,
  },
  data() {
    return {
      reason: '',
    }
  },
  computed: {
    isValid() {
      return this.reason.length > 0
    },
  },
  methods: {
    async reject() {
      try {
        await this.request.reject(this.reason)
        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '却下しました',
        })
        this.$store.dispatch(actions.SEARCH)
        this.close()
      } catch (e) {
        throw e
      }
    },
    close() {
      this.reason = ''
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;
}
</style>
